import { render, staticRenderFns } from "./ModalSelectFreebie.vue?vue&type=template&id=06606d5f&scoped=true"
import script from "./ModalSelectFreebie.vue?vue&type=script&lang=js"
export * from "./ModalSelectFreebie.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectFreebie.vue?vue&type=style&index=0&id=06606d5f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06606d5f",
  null
  
)

export default component.exports